<template>
  <div class="home">
    <el-container>
      <!-- 头部 -->
      <el-header class="top">
        <Headers />
      </el-header>
      <el-container>
        <!-- 菜单 -->
        <el-aside style="width: 225px;">
          <Menus @changeIsAction="changeIsAction" :isActive="isActive" :isOpeneds="isOpeneds" :router="router" />
        </el-aside>
        <!-- 内容 -->
        <el-main style="margin-top: 30px;">
          <div class="home_main">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
    <!-- 修改密码弹出框 -->
    <modaDialogl
      :dialog="dialog"
      :handleClose="handleClose"
    />
  </div>
</template>

<script>
import Headers from "@/components/headers/headers.vue"
import Menus from "@/components/menu/menu.vue"
import modaDialogl from "./HomeDialog.vue"
import "@/assets/css/main.css"

export default {
  components: {
    Headers,
    Menus,
    modaDialogl
  },
  data() {
    return {
      isActive:'',
      isOpeneds:[],
      router:[
        // {
        //   path: "/carbonSinkResources",
        //   info: {
        //       "icon": "el-icon-s-platform",
        //       "title": "碳汇资源管理平台"
        //   }
        // },
        // {
        //   path: "/dataImport",
        //   info: {
        //       "icon": "el-icon-s-platform",
        //       "title": "数据导入"
        //   }
        // },
        //  {
        //   path: "/carbonUptake",
        //   info: {
        //       "icon": "el-icon-s-platform",
        //       "title": "碳汇+N"
        //   }
        // },
        {
          path: "/activitiesAndTravels",
          info: {
            "icon": "el-icon-s-platform",
            "title": "会议/旅游"
          }
        },
        {
          path: "/treePlanting",
          info: {
              "icon": "el-icon-s-platform",
              "title": "义务植树"
          }
        },
        {
          path: "/policyInformation",
          info: {
              "icon": "el-icon-s-platform",
              "title": "政策信息"
          }
        },
       
        // {
        //   path: "/personnelInformation",
        //   info: {
        //       "icon": "el-icon-s-platform",
        //       "title": "人员信息"
        //   }
        // },
        // {
        //   path: "/contributionStatistics",
        //   info: {
        //       "icon": "el-icon-s-platform",
        //       "title": "零碳公司日"
        //   }
        // },
        // {
        //   path: "/classDetails",
        //   info: {
        //       "icon": "el-icon-s-platform",
        //       "title": "零碳课堂明细"
        //   }
        // },
        // {
        //   path: "/carbonLabeling",
        //   info: {
        //       "icon": "el-icon-s-platform",
        //       "title": "碳标签"
        //   }
        // },
        
        {
          path: "/userManagement",
          info: {
              "icon": "el-icon-s-platform",
              "title": "用户管理"
          }
        },
      ],
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "修改密码",
      },
    };
  },
  methods:{
    init(){
      if(!window.localStorage.getItem('passWordFormat')&&!window.localStorage.getItem('userInfo')){
        this.$message.error({message:'用户信息不完整，请先去登录',duration:2000})
        setTimeout(() => {
          this.$router.push('/')
        },1500)
        return false
      }
      this.isActive = this.$route.path;
      this.isOpeneds = this.treeFindPath(
        this.router,
        (data) => data.path === this.isActive
      );
      if(window.localStorage.getItem('passWordFormat')==='false'){
        this.dialog.visible = true
      }else{
        this.dialog.visible = false
      }
    },
    changeIsAction(val){
      this.isActive = val
    },
    treeFindPath(tree, func, path = []) {
      if (!tree) return [];
      for (const data of tree) {
        // 这里按照你的需求来存放最后返回的内容吧
        path.push(data.path);
        // console.log(path);
        if (func(data)) return path;
        if (data.children) {
          const findChildren = this.treeFindPath(data.children, func, path);
          if (findChildren.length) return findChildren;
        }
        path.pop();
      }
      return [];
    },
    //
    handleClose(){
      this.dialog.visible = false
    },
  },
  beforeDestroy() {
  },
  created() {
    this.init();
  },
  watch:{
    $route(to,from){
      this.isActive = to.path
      console.log(from.path);//从哪来
      console.log(to.path);//到哪去
    }
  },
};
</script>
<style scoped>
  .home{
    min-height: 100vh;
  }
 .home .top{
  padding: 0;
  width: 100%;
  height: 90px;
 }
 .el-aside{
  margin: 30px 0 0 0;
  width: 17.66667%  !important;
  height: calc(100vh - 90px);
 }
 .el-main{
  padding: 0 20px;
  background-color: rgba(246, 246, 246, 0.671);
  overflow: hidden;
 }
 .home_main{
  min-height: calc(100vh - 90px);
 }
</style>
